import React, { useState } from "react";
import { useSelector } from "react-redux";

// MUI Imports
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

// Component Imports
import CustomerOrderBody from "./CustomerOrderBody";
import Loading from "../../../../Components/Interactive/Loading";

const CustomerOrderTable = ({
  allCustomerData,
  setUpdatedData,
  setTrigger,
}) => {
  const [loading] = useState(false);
  const {
    userOrders: { orders },
  } = allCustomerData;

  const auth = useSelector(({ auth }) => auth);
  return (  
    <>
      <div className="orders-table">
        <p className="customer-widget-heading" style={{ width: "100%" }}>
          Orders
        </p>
      </div>

      {loading ? (
        <div className="loading-widget">
          <Loading />
        </div>
      ) : (
        <TableContainer
          className="customer-order-table"
          style={{ marginBottom: "20px" }}
        >
          <Table aria-label="collapsible table" style={{ width: "100%" }}>
            <TableHead
              style={{
                backgroundColor: "#FDFAF6",
                borderRadius: "10px !important",
              }}
            >
              <TableRow
                style={{
                  backgroundColor: "#0D2B41",
                }}
              >
                <TableCell />
                <TableCell align="center" className="headerText">
                  Order Number
                </TableCell>
                <TableCell
                  align="center"
                  className="headerText"
                >
                  Campaign
                </TableCell>
                <TableCell align="center" className="headerText">
                  Price
                </TableCell>
                <TableCell align="center" className="headerText">
                  Status
                </TableCell>
                <TableCell align="center" className="headerText">
                  Order Date
                </TableCell>
                <TableCell align="center" className="headerText">
                  ID
                </TableCell>
                <TableCell align="center" className="headerText">
                  Type
                </TableCell>
                <TableCell align="center" className="headerText">
                  Name
                </TableCell>
                <TableCell align="center" className="headerText">
                  Quantity
                </TableCell>
                <TableCell align="center" className="headerText">
                  SKU
                </TableCell>
                <TableCell align="center" className="headerText">
                  Price
                </TableCell>
                <TableCell align="center" className="headerText"></TableCell>
              </TableRow>
            </TableHead>
            <CustomerOrderBody
              orderData={orders}
              allCustomerData={allCustomerData}
              auth={auth}
              setUpdatedData={setUpdatedData}
              setTrigger={setTrigger}
            />
          </Table>
          <div className="bottom-footer"></div>
        </TableContainer>
      )}
    </>
  );
};

export default CustomerOrderTable;
